( function ( $ ) {
    if($(window).width() < 1025 ){
        $(document).on('click', '.pc-widget > h5', function (e) {
            e.preventDefault();
            if (!$(this).parent().hasClass('active')) {
                $('.pc-links').each(function () {
                    $(this).removeClass("active");
                });
                $(this).parent().addClass("active");
            } else {
                $(this).parent().removeClass("active");
            }
        });
    }
})( jQuery );